import(/* webpackMode: "eager", webpackExports: ["FaqPageContent"] */ "/app/components/frontend/faq/faq-page-content.tsx");
